// src/pages/Unauthorized.jsx
export default function Unauthorized() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-red-50 px-4">
      <div className="text-center p-6 sm:p-10 bg-white shadow-lg rounded-lg max-w-md w-full">
        <h1 className="text-3xl sm:text-4xl font-bold mb-4 text-red-800">
          Unauthorized Access
        </h1>
        <p className="mb-6 text-red-700 text-base sm:text-lg">
          You are not allowed to view this page.
        </p>
        <a
          href="/"
          className="inline-block bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors duration-300"
        >
          Go to Home
        </a>
      </div>
    </div>
  );
}
